import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";

import {
  Input,
  MultiLineInput,
  ButtonComposed,
  Select,
  Button,
} from "@lifepay/rc-ui-toolkit";

import {
  SERVICE_DESK_CATEGORIES,
  SERVICE_DESK_SUBCATEGORIES,
} from "./CONSTANTS";

import styles from "./ServiceDeskForm.m.scss";

@themr("@lifepay/ServiceDeskForm", styles)
export default class ServiceDeskForm extends React.Component {
  static get propTypes() {
    return {
      theme: PropTypes.object,
      onSubmit: PropTypes.func,
      onNewRequest: PropTypes.func,
      onPageExit: PropTypes.func,
      requestInProgress: PropTypes.bool,
      requestCompleted: PropTypes.bool,
      error: PropTypes.object,
    };
  }
  static get defaultProps() {
    return {
      requestInProgress: false,
      error: null,
      onSubmit: () => {},
    };
  }

  constructor(props) {
    super(props);
    this.displayName = "ServiceDeskForm";

    const { error } = props;

    const errorMessage = error ? this.getErrorMessage(error) : null;

    this.state = {
      category: null,
      subcategory: null,
      subject: "",
      description: "",
      errorMessage,
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { category, subcategory, subject, description } = this.state;

    if (subject.length && description.length) {
      this.setError({ message: null });
      this.props.onSubmit({
        category,
        subcategory,
        subject,
        description,
        setError: this.setError,
      });
    } else {
      this.setError({ message: "Заполните тему и описание." });
    }
  };

  getErrorMessage = ({ message, code }) => {
    if (message === "no serviceDeskUserName in user profile") {
      return "В профиле пользователя отсутстувует имя пользователя в Service Desk";
    }
    if (message !== undefined) {
      return message;
    }
    switch (code) {
      case 403: {
        return "";
      }
      default: {
        return "Ошибка сети, попробуйте позднее.";
      }
    }
  };

  setError = ({ message, code }) => {
    const errorMessage = this.getErrorMessage({ message, code });
    this.setState({ errorMessage });
  };

  handleChange = ({ value, id }) => {
    if (this.state.error) {
      this.setError({ message: null });
    }
    this.setState({ [id]: value });
  };

  handleClearRequest = () => {
    this.props.onNewRequest && this.props.onNewRequest();
  };

  handlePageExit = () => {
    this.props.onPageExit && this.props.onPageExit();
  };

  render() {
    const { theme, requestInProgress, requestCompleted } = this.props;
    const {
      category,
      subcategory,
      subject,
      description,
      errorMessage,
    } = this.state;

    const valid = subject.length && description.length;
    let buttonState = "normal";
    let btnDisabled = !valid;
    let btnType = "alt";
    if (requestInProgress) {
      buttonState = "loading";
      btnType = "disabled";
      btnDisabled = true;
    }
    if (requestCompleted) {
      buttonState = "success";
      btnType = "disabled";
      btnDisabled = true;
    }

    return (
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.inner)}>
          <form onSubmit={this.handleSubmit}>
            <div className={classnames(theme.inputs)}>
              <Select
                id={"category"}
                value={category}
                chooseAllName={"Не выбрано"}
                options={SERVICE_DESK_CATEGORIES}
                onChange={this.handleChange}
              >
                {"Категория"}
              </Select>
              <Select
                id={"subcategory"}
                value={subcategory}
                chooseAllName={"Не выбрано"}
                placeholder={
                  category ? "Выберите из списка" : "Выберите категорию"
                }
                options={category ? SERVICE_DESK_SUBCATEGORIES[category] : []}
                onChange={this.handleChange}
              >
                {"Подкатегория"}
              </Select>
              <Input
                onChange={this.handleChange}
                id="subject"
                value={subject}
                label
              >
                {"Тема"}
              </Input>
              <MultiLineInput
                id="description"
                value={description}
                minRows={5}
                label
                onChange={this.handleChange}
              >
                {"Описание"}
              </MultiLineInput>
              {/* <div className={classnames(theme.hints)}>
              </div> */}
            </div>
            <div className={classnames(theme.submit)}>
              <div
                className={classnames(
                  theme.message,
                  errorMessage ? theme.visible : ""
                )}
              >
                {errorMessage ? (
                  <div className={classnames(theme.message)}>
                    <span>{errorMessage}</span>
                  </div>
                ) : null}
              </div>
              <ButtonComposed
                onClick={this.handleSubmit}
                disabled={btnDisabled}
                type={btnType}
                state={buttonState}
                theme={{
                  wrapper: theme.button,
                }}
              >
                {valid ? "Отправить заявку" : "Заполните тему и описание"}
              </ButtonComposed>
            </div>
          </form>
          {requestCompleted && (
            <div className={classnames(theme.response)}>
              <Button
                onClick={this.handleClearRequest}
                type={"alt"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                {"Еще заявка"}
              </Button>
              <Button
                onClick={this.handlePageExit}
                type={"main"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                {"Вернуться в меню"}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ServiceDeskForm/ServiceDeskForm.js